import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import AUTH_KEYS from 'api/auth/auth.keys';
import { REGION } from 'constants/routes';
import { useNavigate } from 'react-router-dom';
import BRAND_KEYS from '../brand.keys';
import BRAND_MUTATIONS from '../brand.mutation';
import BRAND_QUERIES from '../brand.queries';
export const useFetchBrand = (uid, options = {}) =>
  useQuery({
    queryKey: BRAND_KEYS.BRAND(uid),
    queryFn: () => BRAND_QUERIES.FETCH_BRAND(uid),
    enabled: !!uid,
    staleTime: 1 * 60 * 1000, // 1 minute
    ...options,
  });

export const useCreateBrand = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: BRAND_MUTATIONS.CREATE_BRAND,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: BRAND_KEYS.BRANDS() });
      queryClient.invalidateQueries({ queryKey: AUTH_KEYS.USER_PROFILE() });
    },
  });
};

export const useUpdateBrand = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: BRAND_MUTATIONS.UPDATE_BRAND,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: BRAND_KEYS.BRAND(variables.uid) });
      queryClient.invalidateQueries({ queryKey: AUTH_KEYS.USER_PROFILE() });
    },
  });
};

export const useUpdateBrandAndSubdomain = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: BRAND_MUTATIONS.UPDATE_BRAND_AND_SUBDOMAIN,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: BRAND_KEYS.BRAND(variables.uid) });
      navigate(REGION);
    },
  });
};

export const useUpdateBrandDefaultLookImage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: BRAND_MUTATIONS.UPDATE_BRAND_DEFAULT_LOOK_IMAGE,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: BRAND_KEYS.BRAND(variables.uid) });
      queryClient.invalidateQueries({ queryKey: AUTH_KEYS.USER_PROFILE() });
    },
  });
};

export const useUpdateTheme = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: BRAND_MUTATIONS.UPDATE_THEME,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: BRAND_KEYS.BRANDS() });
      queryClient.invalidateQueries({ queryKey: AUTH_KEYS.USER_PROFILE() });
      if (!variables.is_onboarding) {
        navigate(REGION);
      }
    },
  });
};

export const useUpdateBrandConfiguration = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: BRAND_MUTATIONS.UPDATE_BRAND_CONFIGURATION,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: BRAND_KEYS.BRAND(variables.uid) });
      queryClient.invalidateQueries({ queryKey: AUTH_KEYS.USER_PROFILE() });
    },
  });
};
